import { graphql } from 'gql';

export const bimUpdateWorkOrderChangePriceRationaleGql = graphql(`
    mutation bimUpdateWorkOrderChangePriceRationale(
        $workOrderChangePriceId: Long!
        $input: BimWorkOrderChangePriceRationaleUpdateInput!
    ) {
        bimUpdateWorkOrderChangePriceRationale(workOrderChangePriceId: $workOrderChangePriceId, input: $input) {
            id
            result
            message
            code
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
        }
    }
`);
